import {Injectable} from '@angular/core';
import {WindowReferenceService} from './window-reference.service';
import {Item, Project} from '../../project/shared/project-model';
import {TreeNode} from 'primeng/api';
import {ReferenceBom} from '../../bom/shared/bom-model';
import {SessionStorage} from "ngx-webstorage";
import {RangeDiscount} from "../../admin/shared";
import {RightsService} from "../rights/rights.service";
import {User} from "../user/user";

@Injectable({
  providedIn: 'root'
})

export class ViewCartBomEventDatalayerService {
  private window;

  @SessionStorage() currentItemct: Item;
  @SessionStorage() isNetPriceDisplayed: boolean;
  @SessionStorage() netPriceByPartnerDiscount: RangeDiscount[];
  @SessionStorage() user: User;

  constructor(private windowRef: WindowReferenceService, private rightsService: RightsService) {
    this.window = windowRef.nativeWindow;
  }

  private DataLayerTrigger(viewCartBomEvent) {
    if (viewCartBomEvent) {
      this.window.dataLayer.push({ecommerce: null});
      this.window.dataLayer.push(viewCartBomEvent);
    }
  }

  viewBomEvent(item: Item, currentProject: Project, currency: string, treeData: TreeNode<any>[]) {
    let offerItems: {}[] = [];
    let totalBomPrice = 0;
    const unixTimestamp = Math.floor(Date.now() / 1000);
    let itemGaChunks = [];

    if (treeData) {
      treeData.forEach((offerItemParent) => {
        if (offerItemParent) {
          offerItemParent.children.forEach((offerItemChild) => {
            if (offerItemChild && offerItemChild.data && offerItemChild.data.ref) {
              let eventPrice = this.getBomEventPrice(offerItemChild.data);
              let count = this.parseAndRoundPrice(offerItemChild.data.count);
              totalBomPrice = totalBomPrice + (eventPrice * count);
              offerItems.push({
                item_id: (offerItemChild.data.id) ? offerItemChild.data.id : offerItemChild.data.ref,
                item_name: offerItemChild.data.ref,
                item_list_name: "Bom Viewed",
                item_list_location: `configurator|EcoStruxure PowerBuild Contractors|${currentProject?.id}|${item.id}`,
                item_brand: 'Schneider Electric',
                item_category: offerItemChild.data.category || offerItemParent.data.category,
                price: eventPrice,
                quantity: offerItemChild.data.count,
                configuration_id: item?.id,
                configuration_name: item?.name
              });
            }
            if (offerItemChild) {
              offerItemChild.children.forEach((offerItemSubChild) => {
                if (offerItemSubChild && offerItemSubChild.data && offerItemSubChild.data.ref) {
                  let eventPrice = this.getBomEventPrice(offerItemSubChild.data);
                  let count = this.parseAndRoundPrice(offerItemSubChild.data.count);
                  totalBomPrice = totalBomPrice + (eventPrice * count);
                  offerItems.push({
                    item_id: (offerItemSubChild.data.id) ? offerItemSubChild.data.id : offerItemSubChild.data.ref,
                    item_name: offerItemSubChild.data.ref,
                    item_brand: 'Schneider Electric',
                    item_list_name: "Bom Viewed",
                    item_list_location: `configurator|EcoStruxure PowerBuild Contractors|${currentProject?.id}|${item.id}`,
                    item_category: offerItemChild.data.category || offerItemParent.data.category,
                    price: eventPrice,
                    quantity: offerItemSubChild.data.count,
                    configuration_id: item?.id,
                    configuration_name: item?.name
                  });
                } else {
                  offerItemSubChild.children.forEach((offerItemSubSubChild) => {
                    if (offerItemSubSubChild && offerItemSubSubChild.data && offerItemSubSubChild.data.ref) {
                      let eventPrice = this.getBomEventPrice(offerItemSubSubChild.data);
                      let count = this.parseAndRoundPrice(offerItemSubSubChild.data.count);
                      totalBomPrice = totalBomPrice + (eventPrice * count);
                      offerItems.push({
                        item_id: (offerItemSubSubChild.data.id) ? offerItemSubSubChild.data.id : offerItemSubSubChild.data.ref,
                        item_name: offerItemSubSubChild.data.ref,
                        item_brand: 'Schneider Electric',
                        item_list_name: "Bom Viewed",
                        item_list_location: `configurator|EcoStruxure PowerBuild Contractors|${currentProject?.id}|${item.id}`,
                        item_category: offerItemSubSubChild.data.category || offerItemSubChild.data.category,
                        price: eventPrice,
                        quantity: offerItemSubSubChild.data.count,
                        configuration_id: item?.id,
                        configuration_name: item?.name
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
    itemGaChunks = this.chunkArray(offerItems, 40);

    itemGaChunks.forEach((gaItemArray) => {
      if (gaItemArray && gaItemArray.length > 0) {
        const eventPrice = gaItemArray.reduce((sum, item) => {
          const price = Number(item.price);
          const qty = Number(item.quantity || 0);
          return sum + (price * qty);
        }, 0);

        let eCommerce = {
          currency: currency,
          value: this.parseAndRoundPrice(eventPrice),
          items: gaItemArray,
          cart_id: unixTimestamp,
          value_availability: (this.parseAndRoundPrice(eventPrice) > 0) ? 'true' : 'false',
          item_list_name: "Bom Viewed",
          item_list_location: `configurator|EcoStruxure PowerBuild Contractors`,
        }

        let event = {
          event: "view_cart",
          configurator_id: 46676,
          configurator_name: 'EcoStruxure PowerBuild Contractors',
          add_to_cart_location: 'Bom',
          cta_name: 'Bom',
          project_id: currentProject.id,
          project_name: currentProject.name,
          number_of_configurations: gaItemArray.length,
          ecommerce: eCommerce,
          user_id: this.user.id
        }
        this.DataLayerTrigger(event);
      }
    });
  }

  viewProjectBomEvent(totalPrice: number, currentProject: Project, currency: string, itemsProject: Item[], refsValue: ReferenceBom[]) {
    let offerItems: {}[] = [];
    let totalProjectBomPrice = 0;
    const unixTimestamp = Math.floor(Date.now() / 1000);
    let itemGaChunks = [];

    if (refsValue) {
      refsValue.forEach((offerValue) => {
        let eventPrice = this.getBomEventPrice(offerValue);
        let count = this.parseAndRoundPrice(offerValue.count);
        totalProjectBomPrice = totalProjectBomPrice + (eventPrice * count);
        offerItems.push({
          item_id: (offerValue.id) ? offerValue.id : offerValue.ref,
          item_name: offerValue.ref,
          item_brand: 'Schneider Electric',
          item_list_name: "Project Bom Viewed",
          item_list_location: `configurator|EcoStruxure PowerBuild Contractors|${currentProject?.id}|${offerValue.configurationId}`,
          item_category: offerValue.category,
          price: eventPrice,
          quantity: offerValue.count,
          configuration_id: offerValue.configurationId,
          configuration_name: offerValue.configuration
        });
      });
    }

    itemGaChunks = this.chunkArray(offerItems, 40);

    itemGaChunks.forEach((gaItemArray) => {
      if (gaItemArray && gaItemArray.length > 0) {
        const eventPrice = gaItemArray.reduce((sum, item) => {
          const price = Number(item.price);
          const qty = Number(item.quantity || 0);
          return sum + (price * qty);
        }, 0);

        let eCommerce = {
          currency: currency,
          value: this.parseAndRoundPrice(eventPrice),
          items: gaItemArray,
          cart_id: unixTimestamp,
          value_availability: (this.parseAndRoundPrice(eventPrice) > 0) ? 'true' : 'false',
          item_list_name: "Project Bom Viewed",
          item_list_location: `configurator|EcoStruxure PowerBuild Contractors`,
        }

        let event = {
          event: "view_cart",
          add_to_cart_location: 'Project Bom',
          configurator_id: 46676,
          configurator_name: 'EcoStruxure PowerBuild Contractors',
          cta_name: 'Project Bom',
          project_id: currentProject.id,
          project_name: currentProject.name,
          number_of_configurations: gaItemArray.length,
          ecommerce: eCommerce,
          user_id: this.user.id
        }
        this.DataLayerTrigger(event);
      }
    });
  }

  private getBomEventPrice(refsValue: ReferenceBom) {
    let unitPrice = 0;
    if (refsValue.discountUnitPrice && refsValue.discountUnitPrice !== 0 && this.rightsService.canApplyDiscount()) {
      unitPrice = this.parseAndRoundPrice(refsValue.discountUnitPrice);
    } else if (refsValue.netPrice && refsValue.netPrice !== 0) {
      unitPrice = this.parseAndRoundPrice(refsValue.netPrice);
    } else if (refsValue.price && refsValue.price !== 0) {
      unitPrice = this.parseAndRoundPrice(refsValue.price);
    } else if (refsValue.discountedNetPrice && refsValue.count !== 0 && this.rightsService.canApplyDiscount()) {
      unitPrice = this.parseAndRoundPrice(refsValue.discountedNetPrice) / this.parseAndRoundPrice(refsValue.count);
    } else if (refsValue.totalNetPrice && refsValue.count !== 0) {
      unitPrice = this.parseAndRoundPrice(refsValue.totalNetPrice) / this.parseAndRoundPrice(refsValue.count);
    } else if (refsValue.totalPrice && refsValue.count !== 0) {
      unitPrice = this.parseAndRoundPrice(refsValue.totalPrice) / this.parseAndRoundPrice(refsValue.count);
    }
    unitPrice = this.parseAndRoundPrice(unitPrice);
    return unitPrice;
  }

  private parseAndRoundPrice(price: string | number): number | null {
    if (price === null || price === undefined) return 0;
    const priceString = price.toString();
    const parsedPrice = parseFloat(priceString.replace(/\s+/g, ''));
    if (!isNaN(parsedPrice)) {
      return Math.round(parsedPrice * 100) / 100;
    }
    return 0;
  }

  private chunkArray<T>(arr: T[], size: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i <= arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  }
}
